module.exports = __webpack_public_path__ + "static/locked.43a74651.png";